/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_AssetInputs */

const en_delete_asset = /** @type {(inputs: Delete_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Asset`)
};

const es_delete_asset = /** @type {(inputs: Delete_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar activo`)
};

const fr_delete_asset = /** @type {(inputs: Delete_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer le bien`)
};

const de_delete_asset = /** @type {(inputs: Delete_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset löschen`)
};

const ja_delete_asset = /** @type {(inputs: Delete_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アセットを削除`)
};

const zh_delete_asset = /** @type {(inputs: Delete_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除资产`)
};

const ar_delete_asset = /** @type {(inputs: Delete_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حذف الأصل`)
};

const id_delete_asset = /** @type {(inputs: Delete_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hapus Aset`)
};

const it_delete_asset = /** @type {(inputs: Delete_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina Risorsa`)
};

const ru_delete_asset = /** @type {(inputs: Delete_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить ресурс`)
};

const pt_delete_asset = /** @type {(inputs: Delete_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir Ativo`)
};

const ko_delete_asset = /** @type {(inputs: Delete_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`에셋 삭제`)
};

/**
* | output |
* | --- |
* | "Delete Asset" |
*
* @param {Delete_AssetInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const delete_asset = /** @type {((inputs?: Delete_AssetInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_AssetInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delete_asset(inputs)
	if (locale === "es") return es_delete_asset(inputs)
	if (locale === "fr") return fr_delete_asset(inputs)
	if (locale === "de") return de_delete_asset(inputs)
	if (locale === "ja") return ja_delete_asset(inputs)
	if (locale === "zh") return zh_delete_asset(inputs)
	if (locale === "ar") return ar_delete_asset(inputs)
	if (locale === "id") return id_delete_asset(inputs)
	if (locale === "it") return it_delete_asset(inputs)
	if (locale === "ru") return ru_delete_asset(inputs)
	if (locale === "pt") return pt_delete_asset(inputs)
	return ko_delete_asset(inputs)
});